interface IconProps {
  className?: string;
}

const strokeProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function SunIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 3v2M12 19v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M3 12h2M19 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" />
    </svg>
  );
}

export function MoonIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <path d="M20 14.5A8.5 8.5 0 119.5 4 6.5 6.5 0 0020 14.5z" />
    </svg>
  );
}

export function ShareIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <path d="M12 15V4" />
      <path d="M7.5 8.5L12 4l4.5 4.5" />
      <rect x="4.5" y="12.5" width="15" height="7" rx="1.5" />
    </svg>
  );
}

export function MedalIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <circle cx="12" cy="14.5" r="6.5" />
      <path d="M9.5 8.5L7 2.5M14.5 8.5L17 2.5" />
      <path d="M12 11.5v6M9.5 14.5h5" />
    </svg>
  );
}

export function SearchIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="M20 20l-4.8-4.8" />
    </svg>
  );
}

export function UserIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M4.5 19.5a7.5 7.5 0 0115 0" />
    </svg>
  );
}

export function UsersIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 19a6 6 0 0112 0" />
      <path d="M15 6.5a3 3 0 010 5.8" />
      <path d="M15.5 13a6 6 0 015.5 6" />
    </svg>
  );
}

export function LinkIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <rect x="3" y="8" width="8" height="8" rx="3" />
      <rect x="13" y="8" width="8" height="8" rx="3" />
      <path d="M11 12h2" />
    </svg>
  );
}

export function EyeIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function CloseIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}
